import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * Converts a date or date range to UTC timestamps based on user's local timezone
 * This ensures that when a user in Mexico selects "January 29", they get data
 * for January 29 in Mexico time (CST), not UTC
 *
 * @param date - Single Date or array of [startDate, endDate]
 * @returns Object with start and end Date objects in UTC
 */
export function useDateRange(date: Date | Date[]) {
  // Get user's timezone from browser
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  // Handle array (date range)
  if (Array.isArray(date)) {
    if (date.length !== 2 || !date[0] || !date[1]) {
      return {
        start: null,
        end: null,
      }
    }

    // Start of first day in user's timezone, converted to UTC
    const start = dayjs(date[0])
      .tz(userTimezone)
      .startOf('day')
      .utc()
      .toDate()

    // End of last day in user's timezone, converted to UTC
    const end = dayjs(date[1])
      .tz(userTimezone)
      .endOf('day')
      .utc()
      .toDate()

    return { start, end }
  }

  // Handle single date
  if (!(date instanceof Date)) {
    return {
      start: null,
      end: null,
    }
  }

  if (!date) {
    return {
      start: null,
      end: null,
    }
  }

  // Start of day in user's timezone, converted to UTC
  const start = dayjs(date)
    .tz(userTimezone)
    .startOf('day')
    .utc()
    .toDate()

  // End of day in user's timezone, converted to UTC
  const end = dayjs(date)
    .tz(userTimezone)
    .endOf('day')
    .utc()
    .toDate()

  return { start, end }
}
